

<template>
  <div class="function-block container-width">
    <div>
      <router-link to="/jyzn">
        <span class="iconfont icon-jiuyizhinanhui"></span>
        <p class="title">就医指南</p>
        <p class="en-title" v-if="DWIDTH">MEDICAL GUIDE</p>
      </router-link>
    </div>
    <div>
      <a @click="dialogVisible = true">
        <span class="iconfont icon-wangshangyuyue"></span>
        <p class="title">手机预约</p>
        <p class="en-title" v-if="DWIDTH">MOBILE BOOKING PLATFORM</p>
      </a>
    </div>
    <div>
      <router-link to="/ylts/home">
        <span class="iconfont icon-keshi"></span>
        <p class="title">科室介绍</p>
        <p class="en-title" v-if="DWIDTH">DEPARTMENT INTRODUCTION</p>
      </router-link>
    </div>
    <div>
      <router-link to="/ylts/mingyi">
        <span class="iconfont icon-mingyi"></span>
        <p class="title">盛京名医</p>
        <p class="en-title" v-if="DWIDTH">SHENGJING DOCTORS</p>
      </router-link>
    </div>
    <div>
      <router-link to="/lxwm/dean">
        <span class="iconfont icon-xinfeng"></span>
        <p class="title">联系我们</p>
        <p class="en-title" v-if="DWIDTH">CONTACT US</p>
      </router-link>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="75%"
      :append-to-body="true"
      title="手机预约"
    >
      <div v-html="onlilneUrl"></div>
    </el-dialog>
  </div>
</template>
        
<script>
import service from "../../service/index";
export default {
  name: "FUNCTIONBLOCK",
  props: {},
  data() {
    return {
      dialogVisible: false, //dialog 显影
      onlilneUrl: "", // 手机预约 图片地址
      DWIDTH: true,
    };
  },
  methods: {
    // 手机预约图片地址
    getOnLineImgData() {
      service.getOnlineInfo({}, (res) => {
        this.onlilneUrl = res.description || "";
      });
    },
  },
  mounted() {
    // 手机预约图片地址
    this.getOnLineImgData();
    if (window.screen.width < 720) {
      this.DWIDTH = false;
    } else {
      this.DWIDTH = true;
    }
  },
  watch: {},
  destroyed() {},
};
</script>
        
<style scoped lang="scss">
/* 功能模块 */
.function-block {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  div {
    border-radius: 5px;
    a {
      box-sizing: border-box;
      height: 140px;
      display: -webkit-flex;
      display: flex;
      -webkit-justify-content: center;
      justify-content: center;

      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      align-items: center;
      color: #fff;
      cursor: pointer;
      span {
        color: #fff;
        font-size: 2.85rem;
      }
      span:hover {
        animation: rot 0.5s;
        -webkit-animation: rot 0.5s;
      }
      .title {
        font-size: 1.4rem;
        text-align: center;
      }
      .en-title {
        font-size: 0.875rem;
        text-align: center;
      }
    }
  }
  div:hover {
    transition: all 0.2s linear;
  }
  div:nth-child(1) {
    background-color: #5381d7;
  }
  div:nth-child(2) {
    background-color: #335baa;
  }
  div:nth-child(3) {
    background-color: #00479d;
  }
  div:nth-child(4) {
    background-color: #b29b6b;
  }
  div:nth-child(5) {
    background-color: #842331;
    margin-right: 0%;
  }
}
@media only screen and (max-width: 420px) {
  .function-block {
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 30px;
    grid-column-gap: 5px;
    div {
      a {
        height: 80px;
        span {
          font-size: 2rem;
        }
        .title {
          font-size: 0.8rem;
        }
        .en-title {
          display: none;
        }
      }
    }
  }
}
@media only screen and (max-width: 720px) {
  .function-block {
    padding: 0 10px;
    box-sizing: border-box;
    margin-top: 30px;
    grid-column-gap: 5px;
    div {
      a {
        height: 80px;
        span {
          font-size: 2rem;
        }
        .title {
          font-size: 0.8rem;
        }
        .en-title {
          display: none;
        }
      }
    }
  }
}
@media only screen and (max-width: 1280px) {
  .function-block {
    div {
      a {
        // height: 120px;
        span {
          font-size: 2rem;
        }
        .title {
          font-size: 1rem;
        }
        .en-title {
          font-size: 0.8rem;
        }
      }
    }
  }
}
</style>
        
      
         